import { RewardModel, VipLevelRewardModel } from '@shared/types';

import { VipLevelRewardFormValues } from '../../VipSettingsForms';

export const getLevelFormValuesFromModel = (level: VipLevelRewardModel, initialLevelRewards: RewardModel[]) => {
  const { id, rewardIds, ...restFields } = level;

  const formValues: VipLevelRewardFormValues = {
    ...restFields,
    levelRewards: initialLevelRewards,
  };

  return formValues;
};
